export const categoryFromAPI = {

    'Placas de Vídeo': 'gpus',
    'Placa de Vídeo': 'gpus',

    'Processadores': 'cpus',
    'Processador': 'cpus',

    'Memórias RAM': 'rams',
    'Memória RAM': 'rams',

    'Coolers': 'cpu_coolers',
    'Cooler': 'cpu_coolers',

    'Placas-Mãe': 'motherboards',
    'Placa-Mãe': 'motherboards',

    'Fontes': 'power_supplies',
    'Fonte': 'power_supplies',

    'Gabinetes': 'cases',
    'Gabinete': 'cases',

    'Armazenamentos': 'storages',
    'Armazenamento': 'storages'
    
}